import axios from 'axios';
import { Config } from 'config/envConfig';
import { getUrl } from './getUrl';

// Unlike loadPaymentScript/loadRenewalPaymentScript (which redirect the whole
// page to callback_url and let the server-side redirect land on the SPA),
// top-up uses Razorpay's in-page `handler` so the modal can show a
// downloadable receipt immediately without a full navigation.
export function loadTopupPaymentScript(user, data, { onSuccess, onError, onDismiss } = {}) {
    const script = document.createElement('script');
    script.src = 'https://checkout.razorpay.com/v1/checkout.js';
    script.onload = () => {
        const options = {
            key: Config.RAZORPAY_API_KEY,
            amount: data.amount,
            currency: data.currency,
            order_id: data.order_id,
            name: 'Quyva Credit Top-up',
            description: `${data.credits} credits`,
            handler: async (response) => {
                try {
                    const verifyRes = await axios.post(
                        getUrl(
                            `http://${Config.NODE_SERVER_HOST}:${Config.NODE_SERVER_PORT}/topup-payment-verification`
                        ),
                        {
                            razorpay_order_id: response.razorpay_order_id,
                            razorpay_payment_id: response.razorpay_payment_id,
                            razorpay_signature: response.razorpay_signature,
                        }
                    );
                    onSuccess?.(verifyRes.data);
                } catch (err) {
                    onError?.(
                        err.response?.data?.error ||
                            'Payment succeeded but verification failed. Please contact support.'
                    );
                }
            },
            prefill: { name: user.username, email: user.email },
            readonly: { email: true },
            notes: { email: user.email },
            modal: {
                ondismiss: () => onDismiss?.(),
            },
        };
        const rzp1 = new window.Razorpay(options);
        rzp1.on('payment.failed', (resp) => {
            onError?.(resp.error?.description || 'Payment failed');
        });
        rzp1.open();
    };
    script.onerror = () => {
        console.error('Razorpay script failed to load.');
        onError?.('Failed to load payment gateway');
    };
    document.body.appendChild(script);
}
